// List, create, update, and delete claims.
import axios from "axios";
import jsonFormData from "json-form-data";

const prepareData = (data) => {
  return jsonFormData({ administration_claim: data }, { showLeafArrayIndexes: true });
};

export const GET_ADMINISTRATION_CLAIMS = "get_administration_claims";
export const getAdministrationClaims = (month, monthBy, projectId) => {
  const url = `/administration/claims.json`;
  const params = {};
  if (month) params.month = month;
  if (month && monthBy) params.month_by = monthBy;
  if (projectId) params.project_id = projectId;
  const request = axios.get(url, { params });
  return {
    type: GET_ADMINISTRATION_CLAIMS,
    payload: request,
  };
};

export const CREATE_ADMINISTRATION_CLAIM = "create_administration_claim";
export const createAdministrationClaim = (data) => {
  const url = `/administration/claims.json`;
  const request = axios({ method: "post", url: url, data: prepareData(data) });
  return {
    type: CREATE_ADMINISTRATION_CLAIM,
    payload: request,
  };
};

export const GET_ADMINISTRATION_CLAIM = "get_administration_claim";
export const getAdministrationClaim = (id) => {
  const url = `/administration/claims/${id}.json`;
  const request = axios.get(url);
  return {
    type: GET_ADMINISTRATION_CLAIM,
    payload: request,
  };
};

export const UPDATE_ADMINISTRATION_CLAIM = "update_administration_claim";
export const updateAdministrationClaim = (id, data) => {
  const url = `/administration/claims/${id}.json`;
  const request = axios({ method: "patch", url: url, data: prepareData(data) });
  return {
    type: UPDATE_ADMINISTRATION_CLAIM,
    payload: request,
  };
};

export const DESTROY_ADMINISTRATION_CLAIM = "destroy_administration_claim";
export const destroyAdministrationClaim = (id) => {
  const url = `/administration/claims/${id}.json`;
  const request = axios({ method: "delete", url: url });
  return {
    type: DESTROY_ADMINISTRATION_CLAIM,
    payload: request,
  };
};

export const LINK_ADMINISTRATION_CLAIM_INVOICE = "link_administration_claim_invoice";
export const linkClaimInvoice = (id, invoiceNumber) => {
  const request = axios.post(`/administration/claims/${id}/link_invoice.json`, { invoice_number: invoiceNumber });
  return {
    type: LINK_ADMINISTRATION_CLAIM_INVOICE,
    payload: request,
  };
};

export const LINK_RETENTION_INVOICE = "link_retention_invoice";
export const linkRetentionInvoice = (id, invoiceNumber) => {
  const request = axios.post(`/administration/claims/${id}/link_retention_invoice.json`, { invoice_number: invoiceNumber });
  return {
    type: LINK_RETENTION_INVOICE,
    payload: request,
  };
};

export const CREATE_ADMINISTRATION_CLAIM_INVOICE = "create_administration_claim_invoice";
export const createClaimInvoice = (id, data) => {
  const request = axios.post(`/administration/claims/${id}/create_invoice.json`, data);
  return {
    type: CREATE_ADMINISTRATION_CLAIM_INVOICE,
    payload: request,
  };
};

export const getNextClaimNumber = (projectId, variationNumberId) => {
  const params = { project_id: projectId };
  if (variationNumberId) params.variation_number_id = variationNumberId;
  return axios.get(`/administration/claims/next_number.json`, { params });
};

export const getClaimDescriptions = () => axios.get("/administration/claim_descriptions.json");

export const createClaimDescription = (name) => {
  return axios.post("/administration/claim_descriptions.json", { administration_claim_description: { name } });
};

const saveBlob = (response, fallbackName) => {
  const type = response.data?.type || "";
  if (type.includes("text/html")) {
    return Promise.reject(new Error("Could not download the file."));
  }

  const header = response.headers["content-disposition"] || "";
  const match = /filename="([^"]+)"/.exec(header);
  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = match ? match[1] : fallbackName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// A normal link does not send the login token, so Rails would bounce the download to sign-in.
export const downloadClaimSheet = (params) => {
  return axios.get("/administration/claims/export", { params, responseType: "blob" }).then((response) => {
    return saveBlob(response, "MJH Engineering.xls");
  });
};

export const downloadClaimPdf = (claim) => {
  return axios.get(`/administration/claims/${claim.id}.pdf`, { responseType: "blob" }).then((response) => {
    return saveBlob(response, `${claim.project_number || "Claim"} - Claim ${claim.claim_number}.pdf`);
  });
};

export const claimErrorMessage = (error) => {
  const data = error?.response?.data;
  if (typeof data?.error === "string") return data.error;
  if (!_.isPlainObject(data)) return "Could not save claim";

  return _.flatMap(data, (messages, key) => _.castArray(messages).map((message) => `${_.startCase(key)} ${message}`)).join(". ");
};
